import React from "react";

const fmtMonto = (val) => {
  try {
    const n = Number(val);
    if (Number.isNaN(n)) return String(val);
    return n.toLocaleString("es-VE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  } catch { return String(val); }
};

const fmtPeriodo = (dateStr) => {
  if (!dateStr) return "—";
  try {
    const [y, m] = dateStr.split("T")[0].split("-");
    const meses = ["", "enero", "febrero", "marzo", "abril", "mayo", "junio",
                   "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
    return `${meses[Number(m)]} ${y}`;
  } catch { return String(dateStr); }
};

export default function ModalEstimateBilling({ estimacion, isOpen, onClose, onCortar }) {
  if (!isOpen || !estimacion) return null;
  const e = estimacion;
  const yaExiste = !!e.ya_existe_corte;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={onClose}>
      <div
        className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full overflow-hidden max-h-[90vh] flex flex-col"
        onClick={(ev) => ev.stopPropagation()}
      >
        <div className="bg-sirius-night px-6 py-4 flex justify-between items-center" style={{ background: "#1e293b" }}>
          <div>
            <h3 className="text-white text-lg font-bold">Estimación de corte de cobranza</h3>
            <p className="text-white/60 text-xs mt-1 capitalize">
              Periodo: {fmtPeriodo(e.periodo)}
              {e.fecha_calculo ? ` · Calculado el ${e.fecha_calculo}` : ""}
            </p>
          </div>
          <button onClick={onClose} className="text-white/70 hover:text-white">
            <i className="fas fa-times text-lg"></i>
          </button>
        </div>

        <div className="p-6 overflow-y-auto">
          {yaExiste && (
            <div className="bg-amber-50 border border-amber-300 rounded-lg p-3 mb-4 text-amber-800 text-sm">
              <i className="fas fa-triangle-exclamation mr-2"></i>
              <strong>Atención:</strong> ya existe un corte ejecutado para este periodo. No se puede crear otro.
            </div>
          )}

          <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-4">
            <div className="bg-blueGray-50 rounded-lg p-3">
              <p className="text-xs text-blueGray-500 uppercase font-bold">Empresas</p>
              <p className="text-2xl font-bold text-blueGray-700">{e.nro_empresas_recaudadas}</p>
            </div>
            <div className="bg-violet-50 rounded-lg p-3">
              <p className="text-xs text-violet-700 uppercase font-bold">Facturas</p>
              <p className="text-2xl font-bold text-violet-700">{e.nro_facturas_acumulada ?? 0}</p>
            </div>
            <div className="bg-emerald-50 rounded-lg p-3">
              <p className="text-xs text-emerald-700 uppercase font-bold">Monto Bs.</p>
              <p className="text-2xl font-bold text-emerald-700">{fmtMonto(e.monto_acumulado)}</p>
            </div>
            <div className="bg-sky-50 rounded-lg p-3">
              <p className="text-xs text-sky-700 uppercase font-bold">Monto USD*</p>
              <p className="text-2xl font-bold text-sky-700">{fmtMonto(e.monto_acumulado_aplicada)}</p>
            </div>
            <div className="bg-indigo-50 rounded-lg p-3">
              <p className="text-xs text-indigo-700 uppercase font-bold">Tasa BCV</p>
              <p className="text-2xl font-bold text-indigo-700">{e.tasa_bcv_aplicada ? fmtMonto(e.tasa_bcv_aplicada) : "—"}</p>
            </div>
          </div>

          {(e.detalles || []).length === 0 ? (
            <div className="p-8 text-center text-blueGray-400">
              No hay empresas a cobrar para este periodo.
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-blueGray-100">
                  <tr className="text-blueGray-700">
                    <th className="text-left py-2 px-3">RIF</th>
                    <th className="text-left py-2 px-3">Razón social</th>
                    <th className="text-right py-2 px-3">Volumen</th>
                    <th className="text-left py-2 px-3">Regla aplicada</th>
                    <th className="text-left py-2 px-3">Tipo</th>
                    <th className="text-right py-2 px-3">Tarifa</th>
                    <th className="text-right py-2 px-3">Monto Bs.</th>
                    <th className="text-right py-2 px-3">Monto orig.</th>
                  </tr>
                </thead>
                <tbody>
                  {e.detalles.map((d) => (
                    <tr key={d.empresa_id} className="border-t hover:bg-blueGray-50/50">
                      <td className="py-2 px-3 font-mono text-xs">{d.empresa_rif}</td>
                      <td className="py-2 px-3">{d.empresa_nombre}</td>
                      <td className="py-2 px-3 text-right font-bold">{d.nro_factura}</td>
                      <td className="py-2 px-3">{d.regla_nombre}</td>
                      <td className="py-2 px-3">
                        {d.regla_tipo === "lote" ? (
                          <span className="bg-indigo-100 text-indigo-700 py-0.5 px-2 rounded-full text-xs font-semibold">Lote</span>
                        ) : (
                          <span className="bg-sky-100 text-sky-700 py-0.5 px-2 rounded-full text-xs font-semibold">Por factura</span>
                        )}
                      </td>
                      <td className="py-2 px-3 text-right text-xs">{fmtMonto(d.regla_monto)} {d.regla_moneda_codigo || ""}</td>
                      <td className="py-2 px-3 text-right font-bold">{fmtMonto(d.monto)}</td>
                      <td className="py-2 px-3 text-right">{fmtMonto(d.monto_aplicada)} {d.regla_moneda_codigo || ""}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        <div className="px-6 py-4 bg-blueGray-50 flex justify-between items-center gap-2 border-t">
          <p className="text-xs text-blueGray-500">
            * Monto USD = monto Bs / tasa_bcv al día del cálculo.
          </p>
          <div className="flex gap-2">
            <button
              onClick={onClose}
              className="bg-blueGray-300 hover:bg-blueGray-400 text-blueGray-800 font-semibold py-2 px-5 rounded"
            >Cerrar</button>
            {!yaExiste && (e.detalles || []).length > 0 && (
              <button
                onClick={onCortar}
                className="bg-emerald-600 hover:bg-emerald-700 text-white font-semibold py-2 px-5 rounded shadow"
              >
                <i className="fas fa-paper-plane mr-2"></i> Confirmar y crear corte
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
